var $5cd99c404e06eb9f$exports = {};
$5cd99c404e06eb9f$exports = {
    "backButton": (args)=>`Tagasi ${args.prevMenuButton}`,
    "moreActions": `Veel toiminguid`,
    "unavailable": `Pole k\xe4ttesaadav, \xfcksikasjade vaatamiseks laiendage`
};


export {$5cd99c404e06eb9f$exports as default};
//# sourceMappingURL=et-EE.module.js.map
